const hideAnimation = (id, hideModal) => {

    const modal = document.getElementById(id)
    if (modal) {
        modal.classList.remove('fade-in')
        modal.classList.add('fade-out')
        if (modal) {
            setTimeout(() => { hideModal() }, 500)
        }
    }
}

export default hideAnimation